import { type SubscriptionTerm } from '@cx-sdk/subs';
import { trackEvent } from '@cx-web/utils/dataLayer';

export const trackComponentWallCtaClick = ({
  feature,
  isUpgrade,
  price,
  selection,
  term,
}: {
  feature: string;
  isUpgrade: boolean;
  price: string;
  selection?: 'Essential' | 'Premium' | 'WhoScored Premium';
  term: SubscriptionTerm | undefined;
}) => {
  trackEvent('paywall_cta', {
    eventLabel: isUpgrade ? 'Upgrade CTA' : 'Paywall CTA',
    feature,
    pageUrl: window.location.href,
    product: `${term} - ${price}`,
    referrerUrl: document.referrer,
    selection,
    upgradeOrPurchase: isUpgrade ? 'Upgrade' : 'Purchase',
  });
};
